window.currentEmailData = {};
window.initEmailOption = false;
window.activeEmailID;
window.activeEmailName;
window.activeEmailType;
window.activeEmailMaster;

(function ($) {
    RVwys.plugin['RightbarEmail'] = true;
    RVwys.rigthbar_email = {};
    RVwys.rigthbar_email.isJstree = {};
    RVwys.rigthbar_email.isJstree.admin = {};
    RVwys.rigthbar_email.isJstree.user = {};

    $(document).bind('editorReady', function () {
        //		Pagebar
        var fb = $('#frameBody').get(0).contentWindow;
        var pageMetatag, pageCss, pageJs, sidebarStyle;
        // Get Current Page Option
        if (
            typeof parent.currentPageJSON != 'undefined' &&
            typeof currentEmailData.email_name != 'undefined'
        ) {
            parent.currentEmailData = parent.currentPageJSON;

            $('.current-optionEmail').attr(
                'email-id',
                parent.currentEmailData.id
            );
            $('.current-optionEmail').attr(
                'email-name',
                parent.currentEmailData.email_name
            );
            $('.current-optionEmail').attr(
                'is-pulbic',
                parent.currentEmailData.is_published
            );

            $('#CurrentType').text(parent.currentEmailData.email_type);
            var dataPasAllEmail = JSON.parse(parent.allEmailDataJSON);
        }

        fb.$('#listEmail').html(''); // clear li

        $('.current-optionEmail').click(function () {
            parent.activeEmailID = $('.current-optionEmail').attr('email-id');
            parent.activeEmailName = $('.current-optionEmail').attr(
                'email-name'
            );
            parent.activeEmailType = $('.current-optionEmail').attr(
                'email-type'
            );
            parent.activeEmailMaster = $('.current-optionEmail').attr(
                'email-master'
            );

            var type = window.currentPageType == 'Category' ? true : false;

            fb.$('.emailSetting').hide();
            fb.$('.bar-rightemai,.bar-category').addClass(
                'bar-category-hidden'
            );

            $('.current-emailSetting').css({ right: '50px', top: '120px' });
            var oThis = $(this);
            var isPublic = oThis.attr('is-pulbic') == 1 ? true : false;

            $('#currentUnsetHide').toggle(!isPublic);
            $('#currentSetHide').toggle(isPublic);

            if (isPublic) {
                var isHomepage = oThis.attr('is-homepage') == 1 ? true : false;
                $('#currentSetHide').toggle(!isHomepage);
                $('#currentSetHomePage').toggle(!isHomepage);

                $('#currentSetHomePage').toggle(!type);
                $('#currentSetHide').toggle(!type);
                $('#currentDuplicate').toggle(!type);

                $('#currentUnsetHide').hide();
            }
        });

        //addEmail
        function getemailcatchkbox(catlist) {
            //for checkbox cat
            var htmlchkbox = '';
            $.each(catlist, function (i, cat) {
                //alert(cat.category_name);
                htmlchkbox =
                    htmlchkbox +
                    '<li><input id="" value="' +
                    cat.id +
                    '" name="email_category" type="radio" class="catSelect" >' +
                    ' ' +
                    cat.category_name +
                    ' <button class="uk-button uk-button-link spancatselect catSelect_' +
                    cat.id +
                    '" id="' +
                    cat.id +
                    '"></button>';
                $.each(cat.subcategories, function (i, subcat1) {
                    //alert(subcat1.category_name);
                    htmlchkbox =
                        htmlchkbox +
                        '<ul class="list-tree1"><li><input id="" value="' +
                        subcat1.id +
                        '" name="email_category" type="radio" class="catSelect" >' +
                        ' ' +
                        subcat1.category_name +
                        ' <button class="uk-button uk-button-link spancatselect catSelect_' +
                        subcat1.id +
                        '" id="' +
                        subcat1.id +
                        '"></button>';
                    $.each(subcat1.subcategories, function (i, subcat2) {
                        //alert(subcat2.category_name);
                    });
                    htmlchkbox = htmlchkbox + '</li></ul>';
                });
                htmlchkbox = htmlchkbox + '</li>';
            });
            return htmlchkbox;
        }

        var editviewAddEmail = fb.$('#editviewAddEmail').html();
        fb.$('.addEmail').click(function () {
            //query all category postCatSelect
            var htmlchkbox = '';
            var htmlselbox = '';
            var url = '/admin/email/category/ajaxgetcategory';
            doAnAjax(url, {}, 'get', function (error, data) {
                if (data.status == 'success') {
                    htmlchkbox = getemailcatchkbox(data.cat);
                    $('#emailCatSelect').html(htmlchkbox);
                    // $('#postCatParent').html(htmlselbox);
                    // eventpost();
                }
            });

            fb.$('.bar-email,.bar-category,.bar-rightemail').addClass(
                'bar-category-hidden'
            );

            var overlaypanel = $(
                '<div class="overlaypanel">' +
                    '<img class="loading" src="' +
                    parent.wex.url.WYS_IMG_URL +
                    'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                    '</div>'
            ).css({
                width: $('body').width(),
                height: $('body').height(),
            });

            var UI = parent.UIkit;
            var options = {
                bgclose: false,
                keyboard: false,
                modal: false,
            };

            var onInsert = function () {
                $('#warningEmailName').hide();
                $.ajax({
                    type: 'POST',
                    url: '/admin/email/update/addemail',
                    data: {
                        email_name: $('#emailName').val(),
                        _token: $('meta[name="csrf-token"]').attr('content'),
                    },
                    success: function (data) {
                        setTimeout(function () {
                            parent.$('.overlaypanel').remove();
                            if (data.status == 'success') {
                                window.location.href =
                                    parent.wex.url.WYS_EMAIL_URL +
                                    '/' +
                                    data.id +
                                    '/' +
                                    data.type;
                            }
                        }, 2500);
                        modal.hide();
                    },
                    error: function (jqXHR, exception) {
                        parent.$('.overlaypanel').remove();

                        var err_page = jqXHR.responseJSON.errors.page_name;
                        modal.element.find('#msgerrEmailpage').html('');
                        $.each(err_page, function (k, v) {
                            //			    		modal.element.find();
                            console.inline.error({
                                target: modal.element.find('#msgerrEmailpage'),
                                text: v,
                                delay: 5000,
                            });
                        });
                    },
                });

                //			}else{
                //				 $('#warningPageName').show();
                //				 $('#pageName').focus().select();
                //			}
                //
            };

            var onNext = function () {
                modal.hide();
                email_templates();
            };
            oncancel = function () {
                modal.hide();
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Add Email') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        editviewAddEmail +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Save') +
                        '</button>',
                    '<button class="uk-button uk-button-success  js-modal-confirm-next">' +
                        rvLang('Next') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">' +
                        rvLang('Cancel') +
                        '</button></div>',
                ].join(''),
                options
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.js-modal-confirm-next')
                .on('click', function () {
                    onNext();
                })
                .end()
                .find('.js-modal-confirm')
                .on('click', function () {
                    onInsert();
                });
            modal.show();

            function email_templates() {
                // call template
                var turl = '/admin/email/emailtemplate';
                doAnAjax(turl, {}, 'get', function (error, data) {
                    var tmodal = UI.modal.dialog(
                        [
                            '<div class="uk-margin uk-modal-header"><h2>' +
                                rvLang('Email Template') +
                                '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                            '<div class="uk-margin uk-modal-content">' +
                                data +
                                '</div>',
                            '<button class="uk-button uk-button-success js-modal-confirm-previous">' +
                                rvLang('Previous') +
                                '</button>',
                            '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                                rvLang('Save') +
                                '</button>',
                            '<button class="uk-button js-modal-confirm-cancel">' +
                                rvLang('Cancel') +
                                '</button></div>',
                        ].join(''),
                        options
                    );
                    tmodal.show();

                    oncancel = function () {
                        tmodal.hide();
                    };

                    var onPrevious = function () {
                        tmodal.hide();
                        modal.show();
                    };

                    tmodal.element
                        .find('.js-modal-confirm-cancel')
                        .on('click', function () {
                            oncancel();
                        })
                        .end()
                        .find('.js-modal-confirm-previous')
                        .on('click', function () {
                            onPrevious();
                        })
                        .end()
                        .find('.js-modal-confirm')
                        .on('click', function () {
                            onInsert();
                        });
                });
            }
        });

        //ajax with callback
        function doAnAjax(url, data, type, callback) {
            $.ajax({
                url: url,
                data: data,
                cache: false,
                type: type,
                error: function () {
                    callback('error', null);
                },
                success: function (data) {
                    callback(null, data);
                },
            });
        }

        $('#setting-email').click(function (e) {
            parent.$('.wys-rowTwo').css({ top: '175px', left: '130px' });
            $('.bar-rightemail').addClass('bar-category-hidden');
            $('.bar-category').addClass('bar-category-hidden');

            $('.bar-rightemail').removeClass('bar-category-hidden');
            $('.bar-emailuser').removeClass('bar-category-hidden');

            var listemailadmin = parent.wex.email.admin.email_lists.concat(
                parent.wex.email.admin.email_listscategory
            );
            RVwys.rigthbar_email.isJstree.createJSTrees(
                $('#listemail_admin'),
                listemailadmin,
                'admin'
            );

            var listemailuser = parent.wex.email.user.email_lists.concat(
                parent.wex.email.user.email_listscategory
            );
            RVwys.rigthbar_email.isJstree.createJSTrees(
                $('#listemail_user'),
                listemailuser,
                'user'
            );
        });

        $('.bar-right-emailadmin a').click(function () {
            var listemail = parent.wex.email.admin.email_lists.concat(
                parent.wex.email.admin.email_listscategory
            );
            RVwys.rigthbar.isJstree.refresh(
                $('#listemail_admin'),
                listemail,
                'admin'
            );
        });

        $('.bar-right-emailuser a').click(function () {
            var listemail = parent.wex.email.user.email_lists.concat(
                parent.wex.email.user.email_listscategory
            );
            RVwys.rigthbar.isJstree.refresh(
                $('#listemail_user'),
                listemail,
                'user'
            );
        });
    });
    //end editorReady

    $(document).bind('designReady', function (e) {
        if (parent.email_type == 'emailcategory') {
            $('#sectionDesignEmail').hide();
            $('#event-email-control').hide();
        }
        var url = window.location.href;
        if (url.match(/\/email\/?/)) {
            $('.bar-left ').hide();
            $('.wys-email').show();
        }

        $('#listEmailAdminSearch').keyup(function () {
            var vEmail = $('#listEmailAdminSearch').val();
            $('#listemail_admin').jstree('search', vEmail);
        });

        $('#listEmailUserSearch').keyup(function () {
            var vEmail = $('#listEmailUserSearch').val();
            $('#listemail_user').jstree('search', vEmail);
        });
    });
    //end designReady
    RVwys.uikit.blockprop.EmailBackground = function () {
        parent.$('.wys-dynamic,.wys-panel,.wys-rowTwo').hide();
        parent.$('.wys-EmailBackgroundDesign, .panelEmailBackground').show();
    };

    RVwys.rigthbar_email.isJstree.createJSTrees = function (
        element,
        data,
        type
    ) {
        var isTypeot = { admin: {}, user: {} };
        //	user
        isTypeot.admin.data = parent.wex.email.admin.email_lists;
        isTypeot.admin.icondefault = 'icon-visibility email-normal';
        isTypeot.admin.iconhome = 'fa fa-home';
        isTypeot.admin.iconexternalmenu = 'fa fa-file-o';
        isTypeot.admin.icondraft = 'uk-icon-edit';
        isTypeot.admin.iconcategory = 'icon-visibility emailcate-normal';

        //	user
        isTypeot.user.data = parent.wex.email.admin.email_lists;
        isTypeot.user.icondefault = 'icon-visibility email-normal';
        isTypeot.user.iconhome = 'fa fa-home';
        isTypeot.user.iconexternalmenu = '';
        isTypeot.user.icondraft = 'uk-icon-edit';
        isTypeot.user.iconcategory = 'icon-visibility emailcate-normal';

        element.prev().find('span').text(isTypeot[type].data.length);

        RVwys.rigthbar_email.isJstree.SetJstree(element, data);
        //	RVwys.rigthbar_email.isJstree.refresh(element,data,type);

        element.jstree({
            core: {
                data: data,
                check_callback: true,
            },
            types: {
                default: {
                    icon: isTypeot[type].icondefault,
                },
                home: {
                    icon: isTypeot[type].iconhome,
                    a_attr: { style: 'font-weight:bold' },
                },
                externalmenu: {
                    icon: isTypeot[type].iconexternalmenu,
                    a_attr: { style: 'color:#BDBDBD' },
                },
                hide: {
                    icon: isTypeot[type].icondraft,
                    a_attr: { style: 'color:#BDBDBD' },
                },
                emailcategory: {
                    icon: isTypeot[type].iconcategory,
                },
            },
            search: {
                case_insensitive: true,
                show_only_matches: true,
                //        	  'search_leaves_only':true
            },
            sort: function (a, b) {
                var nodeA = this.get_node(a);
                var nodeB = this.get_node(b);
                if (nodeA.icon == nodeB.icon) {
                    return nodeA.text > nodeB.text ? 1 : -1;
                }
                return nodeA.icon < nodeB.icon ? 1 : -1;
            },
            plugins: ['types', 'search', 'sort'],
        });

        element.on('ready.jstree', function (event, data) {
            //RVwys.rigthbar_email.isJstree.btnSet($(this));
        });

        element.on('open_node.jstree', function () {
            //RVwys.rigthbar_email.isJstree.btnSet($(this));
        });

        element.on('select_node.jstree', function (e, data) {
            var href = data.node.a_attr.href;
            parent.window.location.href = href;
        });

        element
            .on('search.jstree', function (e, data) {
                //RVwys.rigthbar_email.isJstree.btnSet($(this));
            })
            .on('clear_search.jstree', function (e) {
                //RVwys.rigthbar_email.isJstree.btnSet($(this));
            });
    };

    RVwys.rigthbar_email.isJstree.SetJstree = function (element, data) {
        var cEmail = parent.wex.email.admin.email_lists.length;

        $.each(data, function (k, v) {
            //		set a_attr
            if (v.type == 'emailcategory') {
                var cate_id = v.id.replace('category', '');
                data[k]['a_attr'] = {
                    href:
                        v.hasChild === 'true'
                            ? parent.wex.url.WYS_EMAIL_URL +
                              '/' +
                              cate_id +
                              '/' +
                              v.type
                            : 'javascript:void(0)',
                    title:
                        v.hasChild === 'false'
                            ? rvLang('Will be available soon')
                            : '',
                    style:
                        v.hasChild === 'false'
                            ? 'opacity: 0.5;cursor: not-allowed;'
                            : '',
                };
                data[k]['li_attr'] = {
                    class: 'email email_cate',
                    Indexkey: k - cEmail,
                    'Category-id': v.id,
                    'Category-text': v.text,
                    'is-Child': 1,
                    'email-master': v.master,
                };
                data[k]['state'] = {
                    opened: true,
                };
            } else {
                data[k]['a_attr'] = {
                    href:
                        parent.wex.url.WYS_EMAIL_URL +
                        '/' +
                        v.id +
                        '/' +
                        v.type,
                };
                //			set li_attr
                data[k]['li_attr'] = {
                    class: 'email',
                    Indexkey: k,
                    'email-id': v.id,
                    'email-name': v.text,
                    'is-published': v.is_published,
                    'email-type': v.type,
                    'email-master': v.master,
                };
                data[k]['state'] = {
                    opened: true,
                };
            }
        });
    };

    RVwys.rigthbar_email.isJstree.btnSet = function (oThis) {
        oThis.find('.icon-control').remove();
        oThis.find('li').each(function (k, v) {
            var key = k + 1;
            var id = $(v).attr('id');
            var type = $(v).attr('email-type');

            var othis = oThis.find('#' + id);
            var paramemail = $(
                `<span class="icon-control"><i class="uk-icon-small uk-icon-ellipsis-v editEmail pull-right ${id}"></i></span>`
            );

            var paramcate = $(
                `<span class="icon-control"><i class="uk-icon-small uk-icon-ellipsis-v editCate pull-right ${id}"></i></span>`
            );

            if (!$(v).hasClass('email_cate')) {
                $(v).append(paramemail);
            } else {
                if (oThis.find('#' + id + ':has(ul)').length > 0) {
                    paramcate.insertBefore(othis.find('ul').first());
                } else {
                    $(v).append(paramcate);
                }
            }
        });

        $('.editEmail').click(function (e) {
            var oThis = $(this).closest('li');

            parent.activeEmailType = oThis.attr('email-type');
            parent.activeEmailID = oThis.attr('email-id');
            parent.activeEmailName = oThis.attr('email-name');
            parent.activeEmailMaster = oThis.attr('email-master');

            parent.eleActive = $(e.target).closest('div')[0].id;
            RVwys.rigthbar_email.isJstree.Eventjstree(oThis);

            //				console.log('type '+parent.activeEmailType);
        });

        $('.editCate').click(function () {
            parent.activeEmailType = oThis.attr('email-type');
            parent.activeEmailID = oThis.attr('email-id');
            parent.activeEmailName = oThis.attr('email-name');
            parent.activeEmailMaster = oThis.attr('email-master');

            RVwys.rigthbar_email.isJstree.EventBlog(oThis);
        });
    };

    //  fn::JStree
    RVwys.rigthbar_email.isJstree.Eventjstree = function (oThis) {
        var isThis = '.emailSetting-' + oThis.attr('email-master');
        var isSetting = 'emailSetting-' + oThis.attr('email-master');
        var isPublic = oThis.attr('is-published') == 1 ? true : false;
        var isChild =
            oThis.closest('div').jstree(true).get_node(oThis.attr('id'))
                .children.length > 0;

        $(isThis + ' #setHideEmail').toggle(isPublic);
        $(isThis + ' #unsetHideEmail').toggle(!isPublic);

        var isMaster =
            oThis.attr('email-id') == 'category1' ||
            oThis.attr('email-id') == 'category1'
                ? true
                : false;
        $(isThis + ' #deleteEmail').toggle(!isMaster);

        if (isMaster) {
            $(isThis + ' #setHideEmail').hide();
        }

        if (oThis.attr('email-id') == parent.currentEmailData.id) {
            $(isThis + ' #deleteEmail').hide();
        }

        if (isChild) {
            $(isThis + ' #deleteEmail').toggle(isMaster);
        }

        //		console.log(oThis.attr('page-name'));
        $('.rvsb-design-property').hide();
        $(isThis + ' #titleEmail').text(parent.activeEmailName);
        $('.' + isSetting).show();
        var positionSettingEmail = oThis.position();

        var Maxh = screen.height - positionSettingEmail.top;
        if (Maxh < 350) {
            $('.' + isSetting).css({ right: '200px', top: '410' });
        } else {
            $('.' + isSetting).css({
                right: '200px',
                top: positionSettingEmail.top - 5,
            });
        }
    };
})(jQuery);
